// extracted by mini-css-extract-plugin
export default {"root":"Followers_root__hQIep","spinner":"Followers_spinner__SVcOe","className":"Followers_className__Jkzq2","followers_theme":"Followers_followers_theme__NRgSj"};